import { SubService } from './SubService.interface';
import { Mark } from '@models/Mark/Mark.interface';
import { MarkModel } from '@models/Mark/Mark.model';

export class SubServiceModel implements SubService {
  id?: number;
  title: string;
  marks: Mark[];
  url?: string | null;
  isPopularGlobal: boolean;
  isElectronic: boolean;
  routePath: string;
  openedRoutePath: string;

  constructor(data: any) {
    this.id = data.id ? data.id : null;
    this.title = data.title ? data.title : '';
    this.marks = [];
    if (data.marks) {
      data.marks.forEach((mark: any) => this.marks.push(new MarkModel(mark)));
    }
    this.routePath = data.routePath ? data.routePath : false;
    this.openedRoutePath = data.openedRoutePath ? data.openedRoutePath : false;
    this.isPopularGlobal = data.isPopularGlobal ? data.isPopularGlobal : false;
    this.isElectronic = data.isElectronic ? data.isElectronic : false;
    if (this.isPopularGlobal) {
      this.url = data.formLink ? data.formLink : '';
    } else {
      this.url = data.fullViewLink ? data.fullViewLink : '';
    }
  }
}
